import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEdit,
  FaPlus,
  FaSave,
} from "react-icons/fa"
import { MdCancel, MdDelete } from "react-icons/md"
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Form,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { usePermissionData } from "AppContext"

const ComponentCodeOne = () => {
  document.title = "Component Code 1 | Milano Jewelry"
  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editingItem, setEditingItem] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    const APIdata = await fetchData(setLoading, "component/code/one")
    if (APIdata?.success) setData(APIdata?.data)
  }

  const toggleModal = () => setModalOpen(!modalOpen)
  const handleEdit = item => {
    setEditingItem(item)
    toggleModal()
  }

  const handleSave = async () => {
    if (!editingItem?.componentCodeOne?.trim()) {
      Swal.fire({ title: "Component Code 1 name is required", icon: "warning" })
      return
    }
    if (editingItem?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "component/code/one",
        editingItem?.id,
        editingItem
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Component Code 1 Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => getData(), 1500)
      } else {
        Swal.fire({
          title: "Error Updating Component Code 1",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(
        setLoading,
        "component/code/one",
        editingItem
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Component Code 1 Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => getData(), 1500)
      } else {
        Swal.fire({
          title: "Error Adding Component Code 1",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `You want to Delete this ${item?.componentCodeOne} Component Code 1`,
      icon: "warning",
      showCancelButton: true,
    })
    if (!confirm.isConfirmed) return
    const APIdata = await FetchDeleteData(
      setLoading,
      "component/code/one",
      item?.id
    )
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Component Code 1 Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => getData(), 1500)
    } else {
      Swal.fire({
        title: "Error deleting Component Code 1",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const filtered = useMemo(
    () =>
      data.filter(d =>
        d?.componentCodeOne?.toLowerCase().includes(searchText.toLowerCase())
      ),
    [data, searchText]
  )
  const totalPages = Math.ceil(filtered.length / perPage)
  const paginated = filtered.slice((page - 1) * perPage, page * perPage)

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="Component Code 1" />
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-3">
              <select
                className="form-select"
                style={{ width: "100px" }}
                value={perPage}
                onChange={e => {
                  setPerPage(Number(e.target.value))
                  setPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <Input
                placeholder="Search..."
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value)
                  setPage(1)
                }}
              />
            </div>
            {checkAccess(14, "add") && (
              <Button
                className="btn-blue"
                onClick={() => {
                  toggleModal()
                  setEditingItem({})
                }}
              >
                <FaPlus className="me-1" /> Add
              </Button>
            )}
          </div>
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Component Code 1</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginated.length > 0 ? (
                paginated.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * perPage + index + 1}</td>
                    <td>{item.componentCodeOne}</td>
                    <td>
                      {checkAccess(14, "edit") && (
                        <Button
                          color="success"
                          className="me-2"
                          onClick={() => handleEdit(item)}
                        >
                          <FaEdit />
                        </Button>
                      )}
                      {checkAccess(14, "delete") && (
                        <Button
                          color="danger"
                          onClick={() => handleDelete(item)}
                        >
                          <MdDelete />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No Component Code 1 found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {page} of {totalPages || 1}
            </span>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                disabled={page === 1}
                onClick={() => setPage(p => p - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>
              {(() => {
                const nums = []
                const max = 5
                let start = Math.max(1, page - Math.floor(max / 2))
                let end = start + max - 1
                if (end > totalPages) {
                  end = totalPages
                  start = Math.max(1, end - max + 1)
                }
                for (let i = start; i <= end; i++)
                  nums.push(
                    <Button
                      key={i}
                      color={page === i ? "primary" : "light"}
                      onClick={() => setPage(i)}
                    >
                      {i}
                    </Button>
                  )
                return nums
              })()}
              <Button
                disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(p => p + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
      <Modal isOpen={modalOpen} centered>
        <ModalHeader toggle={toggleModal}>
          {editingItem?.id ? "Edit Component Code 1" : "Add Component Code 1"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <Label>Component Code 1</Label>
            <Input
              type="text"
              value={editingItem?.componentCodeOne || ""}
              onChange={e =>
                setEditingItem(prev => ({
                  ...prev,
                  componentCodeOne: e.target.value.replace(/^\s+/, ""),
                }))
              }
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            <FaSave /> Save
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            <MdCancel /> Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default ComponentCodeOne
